package org.gstechnovos.jexonplastech.sections.product_details.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.gstechnovos.jexonplastech.sections.products.model.Product
import org.jetbrains.compose.web.css.px

@Composable
fun ProductDetailsContent(product: Product) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(topBottom = 50.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        ProductShowcaseSection(
            images = product.images,
            name = product.name,
            category = product.category,
            modelNumber = product.modelNumber
        )

        ProductDescriptionSection(description = product.shortDescription)
        ProductSpecificationsSection(specifications = product.specifications)
        ProductFeaturesSection(features = product.features)
        RelatedProductsSection(
            currentCategory = product.category,
            currentModelToExclude = product.modelNumber
        )
    }
}